module.exports = __webpack_public_path__ + "static/img/精细化2.7b21911.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/精细化2.jpg
// module id = w+g6
// module chunks = 1